var _desc, _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloseSmallDarkblue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icons-navigation/Close-small/Darkblue") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M6.79493333,5.85206667 L11.5089333,1.13806667 C11.7696,0.8774 11.7696,0.456066667 11.5089333,0.1954 C11.2489333,-0.0652666667 10.8269333,-0.0652666667 10.5662667,0.1954 L5.85226667,4.9094 L1.13826667,0.1954 C0.8776,-0.0652666667 0.4556,-0.0652666667 0.1956,0.1954 C-0.0650666667,0.456066667 -0.0650666667,0.8774 0.1956,1.13806667 L4.9096,5.85206667 L0.1956,10.5660667 C-0.0650666667,10.8267333 -0.0650666667,11.2480667 0.1956,11.5087333 C0.3256,11.6387333 0.496266667,11.7040667 0.666933333,11.7040667 C0.836933333,11.7040667 1.0076,11.6387333 1.13826667,11.5087333 L5.85226667,6.79473333 L10.5662667,11.5087333 C10.6969333,11.6387333 10.8669333,11.7040667 11.0376,11.7040667 C11.2082667,11.7040667 11.3789333,11.6387333 11.5089333,11.5087333 C11.7696,11.2480667 11.7696,10.8267333 11.5089333,10.5660667 L6.79493333,5.85206667 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icons-navigation/Close-small/Darkblue"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon",
    transform: "translate(6.000000, 6.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Combined-Shape",
    fill: "#003755",
    xlinkHref: "#path-1"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseSmallDarkblue);
export default __webpack_public_path__ + "static/media/close-small_darkblue.ead14534b822b837c52aa757134b5a21.svg";
export { ForwardRef as ReactComponent };